export const iconstyle = "w-6 h-6 min-w-6 min-h-6 align-middle max-w-6 max-h-6";